












import { Component, Prop, Vue } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import SessionClosedViewModel from "@/models/security/zorgID/sessionClosedViewModel";

@Component
export default class CloseSessionComponent extends Vue {
  private sessionClosedViewModel = new SessionClosedViewModel();

  private btnLogoutEnabled: boolean = SecurityService.getInstance().isLoggedOn();

  private created() {
    this.subscribeToEvents();
  }

  private subscribeToEvents(): void {
    var me = this;
    SecurityService.getInstance().subscribeSessionClosedReceived(x => {
      me.sessionClosed(x);
    });
  }

  public logout() {
    SecurityService.getInstance().closeSession(
      SecurityService.getInstance().sessionId,
    );
  }

  private sessionClosed(model: SessionClosedViewModel) {
    var me = this;
    me.sessionClosedViewModel = model;
    // SecurityService does the 'real' logoff
  }
}
